import React from 'react'
import {
    BrowserRouter,
    Route,
} from "react-router-dom";
// import MainPage from '../pages/MainPage'
import ChatterChannelPage from '../pages/ChatterChannelPage'
import LinkFailurePage from '../pages/LinkFailurePage'
import DownloadPage from '../pages/DownloadPage'
import { CheckSystem } from '../utils/globalFun'

let linkValidity: any = document.getElementById("link_validity")?.getAttribute("content");
linkValidity = !!Number(linkValidity)

const LinkComponent = CheckSystem.isMobile() ? DownloadPage : (linkValidity ? ChatterChannelPage : LinkFailurePage)

const Router = () => {
    return (
        <BrowserRouter>
            <Route exact path="/*" component={LinkComponent} />
        </BrowserRouter>
    )
}

export default Router